import { createContext } from 'react';
import { type SnackbarStatesType } from 'ui/src/components/Snackbar';

type CookieBarContextType = {
  cookieBarState: SnackbarStatesType;
  setCookieBarState: (state: SnackbarStatesType) => void;
};

const CookieBarContext = createContext<CookieBarContextType>({
  cookieBarState: 'Loading',
  setCookieBarState: () => {},
});

export default CookieBarContext;
